module.exports = __webpack_public_path__ + "files/d9e6eecfe27659d4a6fece85e30c50ab.png";